 


$(document).on('click', '.CartDrawer_close', function () {
   $('html').removeClass('js-drawer-open lock-scroll');
   $('#CartDrawer').addClass('is-transitioning');
   $('#CartDrawer').removeClass('drawer--is-open');
   setTimeout(function(){
        $('#CartDrawer').removeClass('is-transitioning');
   }, 600);
});


if($('body').hasClass('template-product')){
   setInterval(function(){
      check_variant_info();
   }, 1800);
}
 
function check_variant_info(){
   var value = $('.product-block form [name="id"]').val();
   $('.variant_tab, .product_net_content').removeClass('active');
   $('.variant_tab[data-id="'+value+'"], .product_net_content[data-id="'+value+'"]').addClass('active');
}

/*============================================================================
  Cart progress bar (mini cart + cart page)
  Milestones come from Theme settings > Cart progress bar (snippets/cart-progress-bar.liquid)
==============================================================================*/
(function () {
   var bars = document.querySelectorAll('[data-cart-progress]');
   if (!bars.length) return;

   function formatMoney(cents) {
      var money = window.theme && theme.Currency
         ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
         : (cents / 100).toFixed(2);
      return money.replace(/<[^>]*>/g, '');
   }

   function getMilestones(el) {
      if (!el._milestones) {
         var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
         var config = JSON.parse(el.querySelector('[data-cart-progress-config]').textContent);
         el._milestones = config
            .map(function (m) {
               m.threshold = Math.round(m.amount * 100 * rate);
               return m;
            })
            .sort(function (a, b) { return a.threshold - b.threshold; });
      }
      return el._milestones;
   }

   function render(el, total) {
      var milestones = getMilestones(el);
      var count = milestones.length;
      var reached = milestones.filter(function (m) { return total >= m.threshold; }).length;
      var next = milestones[reached];
      var last = milestones[reached - 1];

      // Markers are evenly spaced, so fill progresses segment by segment
      var percent = 100;
      if (next) {
         var start = last ? last.threshold : 0;
         var segment = Math.max(0, Math.min(1, (total - start) / (next.threshold - start)));
         percent = ((reached + segment) / count) * 100;
      }
      el.querySelector('[data-cart-progress-fill]').style.width = percent + '%';

      // Hidden on an empty cart, like the app on the live site
      el.hidden = total <= 0;

      // Messages come from theme settings and may contain <b> markup.
      // "Away" text sits above the bar, the last unlocked text below it.
      var message = el.querySelector('[data-cart-progress-message]');
      message.innerHTML = next
         ? (next.away || next.unlocked).replace(/\[amount\]/g, formatMoney(next.threshold - total))
         : '';
      message.hidden = !next;

      var unlocked = el.querySelector('[data-cart-progress-unlocked]');
      unlocked.innerHTML = last ? last.unlocked : '';
      unlocked.hidden = !last;

      var markers = el.querySelector('[data-cart-progress-markers]');
      var icon = el.querySelector('[data-cart-progress-icon]').innerHTML;
      markers.innerHTML = '';
      milestones.forEach(function (m, i) {
         var marker = document.createElement('span');
         marker.className = 'cart-progress__marker' +
            (i < reached ? ' is-reached' : '') +
            (i === reached ? ' is-next' : '');
         marker.style.left = ((i + 1) / count) * 100 + '%';
         marker.title = m.unlocked.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
         marker.innerHTML = icon;
         markers.appendChild(marker);
      });
   }

   function renderAll(total) {
      bars.forEach(function (el) { render(el, total); });
   }

   function refresh() {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
         .then(function (res) { return res.json(); })
         .then(function (cart) { renderAll(cart.total_price); })
         .catch(function () {});
   }

   renderAll(parseInt(bars[0].dataset.cartTotal, 10) || 0);

   document.addEventListener('cart:updated', function (evt) {
      var cart = evt.detail && evt.detail.cart;
      if (cart && typeof cart.total_price === 'number') {
         renderAll(cart.total_price);
      } else {
         refresh();
      }
   });
   document.addEventListener('ajaxProduct:added', refresh);
   document.addEventListener('drawerOpen', refresh);
})();
